export enum TypeDateEnum {
  hours = 'hours',
  days = 'days',
  months = 'months',
  years = 'years'
}
